import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import JobFeeContainer from '../../../Containers/AdminContainer/JobFees';

const JobFeeScreen = () => {
  return <JobFeeContainer />;
};

export default JobFeeScreen;
